import type React from "react";

import Header from "./Header";
import Sidebar from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header />
        {/* Main Content Area */}
        <main className="flex-1 bg-gray-50 overflow-auto p-6">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
